import { render, staticRenderFns } from "./JobStatusBadge.vue?vue&type=template&id=9510dd4e&scoped=true&"
import script from "./JobStatusBadge.vue?vue&type=script&lang=js&"
export * from "./JobStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusBadge.vue?vue&type=style&index=0&id=9510dd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9510dd4e",
  null
  
)

export default component.exports